import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LanguageService } from '../services/language.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageInterceptor implements HttpInterceptor {
  private languageService: LanguageService = inject(LanguageService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    request = request.clone({
      headers: request.headers.set('Accept-Language', this.languageService.locale.code),
    });
    return next.handle(request);
  }
}
